import { Box, Typography } from '@mui/material';

type Params = {
    title: string;
    icon: any;
}

const NavSolicitation = ({ title, icon }: Params) => {
    return (
        <Box sx={{ margin: '.75rem 0 1.0625rem' }}>
            <Box sx={{ display: 'grid', gap: '.75rem', alignItems: 'center', gridTemplateColumns: 'auto auto 1fr' }}>
                {icon}
                <Typography fontSize='1.125rem' fontWeight={600} sx={{ width: 'fit-content' }}>
                    {title}
                </Typography>
                <Box sx={{ display: 'flex', height: '2px', backgroundColor: 'grey.400' }} />
            </Box>
        </Box>
    );
}

export default NavSolicitation;